import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { untilMd } from '../../constants/breakpoints';
import { buttonSizeToHeight } from '../Button';
import { Play } from '../Icons';
import { Mute } from '../Icons/Icon/Mute';
import { Volume } from '../Icons/Icon/Volume';
import { Button, PauseIcon, StyledMuteButton } from './styles';
const StyledButton = styled(Button) `
  padding: 0px;
  background-color: ${o => o.theme.color.fill.background};
  &:hover {
    background-color: ${o => o.theme.color.fill.subtle};
  }
  height: ${o => buttonSizeToHeight(o.size ?? 'medium')};
  width: ${o => buttonSizeToHeight(o.size ?? 'medium')};
  ${untilMd} {
    opacity: 0.8;
  }
`;
export const PauseButton = ({ paused, size = 'medium', ...rest }) => {
    return (_jsx(StyledButton, { type: 'button', borderless: true, size: size, ...rest, children: paused ? _jsx(Play, {}) : _jsx(PauseIcon, {}) }));
};
export const MuteButton = ({ onClick, isMuted, mutedText, notMutedText, size = 'medium' }) => {
    return (_jsx(StyledMuteButton, { "aria-label": !isMuted ? mutedText : notMutedText, type: 'button', onClick: onClick, size: size, borderless: true, children: isMuted ? _jsx(Mute, {}) : _jsx(Volume, {}) }));
};
//# sourceMappingURL=index.js.map